angular
    .module('MW.ContactManager.ActiveOnIcon', [])
    .directive('activeOnIcon', [function() {
        'use strict';

        return {
            restrict: 'E',
            scope: {
                accountType: '@'
            },
            link: function(scope) {
                var icons = {
                    TWITTER: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/twitter.png',
                    FACEBOOK: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/facebook.png',
                    BLOG: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/blog-active-on.svg',
                    OUTLET: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/news.png',
                    LINKEDIN: 'https://assets.meltwater.io/icm-web-assets/static/img/avatars/linkedin_icon.png'
                };

                scope.accountType = scope.accountType || '';
                scope.iconSrc = icons[scope.accountType.toUpperCase()] || icons.OUTLET;
            },
            templateUrl: 'icm-web/views/partials/active_on_icon'
        };
    }]);
